import { Module } from 'vuex';
import { RootState } from '../index';

export interface WorkingDaySetting {
    active: boolean;
    start: number | null;
    end: number | null;
}

export interface ModuleState {
    days: { [key: string]: WorkingDaySetting };
}

const state: ModuleState = {
    days: window.africaOptions.officeSchedule,
};

const module: Module<ModuleState, RootState> = {
    namespaced: true,
    state,
};

export default module;
